// Central permissions/roles config used across admin UI.

export const MENU_KEYS = {
  ACCUEIL: "accueil",
  RESERVATIONS: "reservations",
  BILLETTERIE: "billetterie",
  CONTENU: "contenu",
  ADMINS: "admins",
  PERSONNALISATION: "personnalisation",
};

export const MENU_LABELS = {
  accueil: { label: "Accueil", emoji: "🏠" },
  reservations: { label: "Réservations", emoji: "📅" },
  billetterie: { label: "Billetterie", emoji: "🎟️" },
  contenu: { label: "Contenu", emoji: "📝" },
  admins: { label: "Admins", emoji: "👥" },
  personnalisation: { label: "Personnalisation", emoji: "⚙️" },
};

export const CONTENT_KINDS = ["programme", "ateliers", "restauration"];
export const CONTENT_KIND_LABELS = {
  programme: { label: "Programme", emoji: "🎪" },
  ateliers: { label: "Ateliers", emoji: "🎨" },
  restauration: { label: "Restauration", emoji: "🍔" },
};

// Role presets → recommended default permissions.
// "custom" means the super admin picks freely (no auto-fill).
export const ROLES = [
  {
    key: "super",
    label: "Admin — accès à tout",
    isSuper: true,
    menus: Object.values(MENU_KEYS),
    kinds: [...CONTENT_KINDS],
    limitByAteliers: false,
  },
  {
    key: "ateliers_externe",
    label: "Ateliers externe — réservations de ses ateliers uniquement",
    isSuper: false,
    menus: [MENU_KEYS.RESERVATIONS],
    kinds: [],
    limitByAteliers: true,
  },
  {
    key: "ateliers_comite",
    label: "Ateliers comité — réservations + contenu Ateliers",
    isSuper: false,
    menus: [MENU_KEYS.RESERVATIONS, MENU_KEYS.CONTENU],
    kinds: ["ateliers"],
    limitByAteliers: false,
  },
  {
    key: "finance",
    label: "Finance — Billetterie",
    isSuper: false,
    menus: [MENU_KEYS.BILLETTERIE],
    kinds: [],
    limitByAteliers: false,
  },
  {
    key: "programmation",
    label: "Programmation — Contenu → Programme",
    isSuper: false,
    menus: [MENU_KEYS.CONTENU],
    kinds: ["programme"],
    limitByAteliers: false,
  },
  {
    key: "restauration",
    label: "Restauration — Contenu → Restauration",
    isSuper: false,
    menus: [MENU_KEYS.CONTENU],
    kinds: ["restauration"],
    limitByAteliers: false,
  },
  {
    key: "custom",
    label: "Personnalisé — je choisis chaque droit",
    isSuper: false,
    menus: [],
    kinds: [],
    limitByAteliers: false,
  },
];

export function getRolePreset(key) {
  return ROLES.find((r) => r.key === key) || ROLES.find((r) => r.key === "custom");
}

// Utility: can the current admin access a menu?
export function canAccessMenu(admin, menuKey) {
  if (!admin) return false;
  if (admin.isSuperAdmin) return true;
  return (admin.allowedMenus || []).includes(menuKey);
}

// Utility: can access a content kind?
export function canAccessContentKind(admin, kind) {
  if (!admin) return false;
  if (admin.isSuperAdmin) return true;
  if (!(admin.allowedMenus || []).includes("contenu")) return false;
  return (admin.allowedContentKinds || []).includes(kind);
}
